import { MessageChannel } from "@bullseye/types"

import { useUserContext } from "../providers"
import { useGetRequest } from "./useRequest"

export const useExperienceMessageChannel = (id: string | undefined | null) => {
  const { accessToken } = useUserContext()
  const { data, isLoading, error, refetch, isRefetching } = useGetRequest<{
    data: MessageChannel[]
  }>(
    {
      method: "GET",
      path: `v1/experiences/${id}/message-channels`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
    {
      enabled: !!id && !!accessToken,
    },
  )

  return {
    messageChannel: data?.data?.[0],
    isLoading,
    error,
    refetch,
    isRefetching,
  }
}
